import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ['Padres y madres separados que conviven con un ex conflictivo o manipulador.', 'Personas que sienten que su salud mental depende del humor de la otra persona.', 'Padres que quieren proteger la estabilidad emocional de sus hijos por sobre todas las cosas.', 'Quienes están cansados de que una notificación de WhatsApp les arruine el fin de semana.'];
const notFor = ['Parejas con un divorcio amigable donde la comunicación fluye sin problemas.', 'Personas que todavía buscan usar el conflicto para seguir vinculados emocionalmente con su ex.', 'Quienes no están dispuestos a dejar de tener la "última palabra" en favor de su propia paz.'];
export function WhoIsThisFor() {
  return <section className="bg-offwhite py-24 px-6" data-id="element-279">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-281">
          <h3 className="font-playfair text-2xl font-bold text-slate-900 mb-8 border-b-2 border-green-200 pb-4" data-id="element-282">
            ESTO ES PARA VOS SI...
          </h3>
          <ul className="space-y-6" data-id="element-283">
            {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-284">
                <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-285" />
                <span className="text-slate-700 font-medium leading-relaxed" data-id="element-286">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-287">
          <h3 className="font-playfair text-2xl font-bold text-slate-900 mb-8 border-b-2 border-red-200 pb-4" data-id="element-288">
            ESTO NO ES PARA VOS SI...
          </h3>
          <ul className="space-y-6" data-id="element-289">
            {notFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-290">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-291" />
                <span className="text-slate-600 leading-relaxed" data-id="element-292">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}